export default __webpack_public_path__ + "static/1-c60779c5934cb1ed31e3af77cbaf5666.jpg";